import crypto from 'crypto';

const algorithm = 'aes-256-ctr';
const secretKey = process.env.REACT_APP_ENCRYPT_SECRET;
const iv = crypto.randomBytes(16);

export const encrypt = text => {
    const cipher = crypto.createCipheriv(algorithm, secretKey, iv);
    const encryptedObj = Buffer.concat([cipher.update(text), cipher.final()]);
    const encrypted = encryptedObj.toString('hex');
    return {
        iv: iv.toString('hex'),
        content: encrypted.toString('hex'),
    };
};

export const decrypt = (content, decryptIv) => {
    const decipher = crypto.createDecipheriv(algorithm, secretKey, Buffer.from(decryptIv, 'hex'));

    const decrpyted = Buffer.concat([
        decipher.update(Buffer.from(content, 'hex')),
        decipher.final(),
    ]);

    return decrpyted.toString();
};
